import service from "./service";
import { clearDatadogUser } from "../datadog";

const _logout = async () => {
    var token = sessionStorage.getItem("accessToken");
    var response = await service(true, "admin/auth/logout", null, token, false);
    if (response.status) {
        clearDatadogUser();
        sessionStorage.clear();
        window.location.href = "/"
    }

}

export default _logout